import Home from "../pages/home.vue";

import authRoutes from "../modules/auth/routes";
import { userAccountRoutes } from "../modules/user-accounts/routes";
// import { searchRequestRoutes } from "../modules/search-requests/routes";
import { reportRoutes } from "../modules/reports/routes";
import { productPricesRoutes } from "../modules/product-prices/routes";
import { permittingRoutes } from "../modules/permitting/routes";
import { sitesRoutes } from "../modules/sites/routes";
import { recordsRoutes } from "../modules/records/routes";
import accountingRoutes from "../modules/accounting/routes";
import notificationsRoutes from "../modules/notifications/routes";
import applicationRoutes from "../modules/applications/routes";
import pagesRolesSetting from "../modules/pages-roles-setting/routes";
import financialRoutes from "../modules/financials/routes";
import settingsRoutes from "../modules/settings/routes";
import formsRoutes from "../modules/forms/routes";
import announcementsAdminRoutes from "../modules/announcements/routes";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  // {
  //   path: '/contact-us',
  //   name: 'ContactUs',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../pages/contact-us.vue'),
  // },
  ...authRoutes,
  ...userAccountRoutes,
  // ...searchRequestRoutes,
  ...reportRoutes,
  ...productPricesRoutes,
  ...permittingRoutes,
  ...sitesRoutes,
  ...recordsRoutes,
  ...accountingRoutes,
  ...notificationsRoutes,
  ...applicationRoutes,
  ...pagesRolesSetting,
  ...financialRoutes,
  ...settingsRoutes,
  ...formsRoutes,
  ...announcementsAdminRoutes,

  {
    path: "/unauth",
    name: "UnAuthorized",
    component: () => import(/* webpackChunkName: "unauthorized" */ "../pages/unauthorized.vue"),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import(/* webpackChunkName: "not-found" */ "../pages/not-found.vue"),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: () => import(/* webpackChunkName: "contact-us" */ "../pages/contact-us.vue"),
    meta: {
      showForAllLoggedUsers: false,
      showForGuestUsers: true,
    },
  },
  {
    path: "/email-sent",
    name: "EmailSent",
    component: () => import(/* webpackChunkName: "email-sent" */ "../pages/email-sent.vue"),
    meta: {
      showForAllLoggedUsers: true,
      showForGuestUsers: true,
    },
  },
];

export default routes;
